import { Observable } from "rxjs";
import { StateService } from "./stateService";

export interface MessageBus {
    topic: string;
    source: string;
    jsonPayload: string;
  }
  
const initialState: MessageBus = {
    topic: "",
    source: "",
    jsonPayload: "",
  };


export class MesageBusServiceForRoot extends StateService<MessageBus>{
    public static service: MesageBusServiceForRoot;

    public static getMessageStateService() : MesageBusServiceForRoot {
        if ( this.service === undefined) {
            this.service = new MesageBusServiceForRoot();
        }
        return this.service;
    }

    private constructor() {
        super(initialState);
    }
    
    public subscription(): Observable<MessageBus> {
        return this.subscribe();
    }

    public changeMessageState(error: MessageBus) : void {
        this.changeState(error);
    }

    public get state(): MessageBus {
        return this.state;
    }
}